export default function syncSkillCharacterSkillAdjsFromDetailEntries(character = null) {
  if (!character || !Array.isArray(character.skills)) {
    return character
  }

  const detailAdjs = Array.isArray(character.skill_adjs) ? character.skill_adjs : []

  character.skills.forEach((skill) => {
    const skillNames = [skill?.name, skill?.display_name].filter((value) => value)

    skill.character_skill_adjs = detailAdjs
      .filter((adj) => adj?.source === 'character' && skillNames.includes(adj.name))
      .map((adj) => ({
        id: adj.id ?? null,
        name: adj.name,
        adj_reason: adj.adj_reason,
        adj_value: adj.adj_value,
        character_item: adj.character_item ?? null,
        applied: adj.applied === true,
        rune_name: adj.rune || adj.rune_name || '',
      }))
  })

  return character
}
